import {
  BASKET_ITEM_ADD,
  BASKET_ITEM_REMOVE,
  ADDRESS_SET,
  DELIVERY_METHOD_SET,
  ADD_EXEMPTION,
  PAYMENT_SET,
  CLEAR_PAYMENT_AND_EXEMPTION,
  BASKET_CLEAR,
  START_PAYMENT_JOURNEY,
  SELECTED_PHARMACY_DETAILS_SET,
  GP_REGISTERED_IN_RANGE_SET,
  PHARMACIES_IN_RANGE_SET,
  ODS_SET,
  OFFBOARDING_PHARMACY_MESSAGE_SET,
} from 'helpers/types';

const INITIAL_STATE = {
  started: false,
  basket: [],
  address: {},
  delivery_type: '',
  exemption: {},
  payment: {},
  numContraceptives: 0,
  selectedPharmacyDetails: {},
  gpRegisteredInRange: false,
  pharmaciesInRange: [],
  dspExclusion: false,
  offboardingPharmacyName: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case START_PAYMENT_JOURNEY:
      return {
        ...INITIAL_STATE,
        basket: state.basket,
        numContraceptives: state.numContraceptives,
        selectedPharmacyDetails: state.selectedPharmacyDetails,
        pharmaciesInRange: state.pharmaciesInRange,
        started: true,
      };
    case ADDRESS_SET:
      return {
        ...state,
        address: action.payload,
      };
    case ODS_SET:
      const updatedAddress = { ...state.address, ods_code: action.payload };
      return {
        ...state,
        address: updatedAddress,
      };
    case BASKET_ITEM_ADD:
      return {
        ...state,
        basket: [...state.basket, action.payload.courseid],
        numContraceptives: action.payload.isContraceptive ? state.numContraceptives + 1 : state.numContraceptives,
      };
    case BASKET_ITEM_REMOVE:
      return {
        ...state,
        basket: [...state.basket.filter((item) => item !== action.payload.courseid)],
        numContraceptives: action.payload.isContraceptive ? state.numContraceptives - 1 : state.numContraceptives,
      };
    case BASKET_CLEAR:
      return {
        ...INITIAL_STATE,
      };
    case DELIVERY_METHOD_SET:
      return {
        ...state,
        delivery_type: action.payload,
      };
    case ADD_EXEMPTION:
      return {
        ...state,
        exemption: action.payload,
        payment: {},
      };
    case PAYMENT_SET:
      return {
        ...state,
        payment: action.payload,
        exemption: {},
      };
    case CLEAR_PAYMENT_AND_EXEMPTION:
      return {
        ...state,
        payment: {},
        exemption: {},
      };
    case SELECTED_PHARMACY_DETAILS_SET:
      return {
        ...state,
        selectedPharmacyDetails: action.payload,
      };
    case GP_REGISTERED_IN_RANGE_SET:
      return {
        ...state,
        gpRegisteredInRange: action.payload,
      };
    case PHARMACIES_IN_RANGE_SET:
      return {
        ...state,
        pharmaciesInRange: action.payload.pharmacies,
        dspExclusion: action.payload.dsp_exclusion,
      };
    case OFFBOARDING_PHARMACY_MESSAGE_SET:
      return {
        ...state,
        offboardingPharmacyName: action.payload,
      };
    default:
      return state;
  }
}
